import type { BoxProps, ContainerProps } from '@mui/material'

class DetailStyle {
  static Container: ContainerProps = {
    maxWidth: false,
    disableGutters: true,
    sx: {
      display: 'flex',
      padding: 2,
      gap: '1rem',
      flexDirection: 'column'
    }
  }

  static ImagePlaceholder: BoxProps = {
    sx: {
      height: 200,
      border: '2px dashed #ccc',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#999',
      gap: '0.5rem'
    }
  }

  static ImageBox: BoxProps = {
    sx: {
      height: 200,
      border: '1px solid #eee',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }
  }
}

export default DetailStyle
